import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { FC, useEffect } from 'react';
import { GuideArticle } from './Guide';
import { OfferArticle } from './Offer';
import { useRouter } from 'next/router';
import { setUserCode } from '~/stores/auth';
import { useUser } from '@auth0/nextjs-auth0/client';

export const ClubArticle: FC<{ id: string; isGuide: boolean }> = ({
  id,
  isGuide,
}) => {
  const { user } = useUser();

  const { refetch } = useTypeSafeQuery(
    BackendQueryKeys.ClubPageView(id),
    (req) =>
      req.ClubPageView({ entryId: id, entryType: isGuide ? 'guide' : 'offer' }),
    {
      enabled: false,
      staleTime: Infinity,
      refetchOnMount: false,
    }
  );

  //Set user code used for light login on club offers
  const router = useRouter();
  useEffect(() => {
    if (!router.isReady) return;
    if (
      router.query.acCustomerNo &&
      typeof router.query.acCustomerNo === 'string'
    ) {
      setUserCode(router.query.acCustomerNo);
    }
  }, [router, router.isReady]);

  useEffect(() => {
    if (user) {
      // Only log club page visit if user is logged in
      refetch();
    }
    // eslint-disable-next-line
  }, []);

  if (isGuide) {
    return <GuideArticle id={id} />;
  }

  return <OfferArticle id={id} />;
};
